var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"12"}},[_c('app-title',{attrs:{"text":"Protocolos de seguridad"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }